import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, theme } from 'modules/tetrisTheme';
/**
 * The shared chrome every button in the family paints: typography, border box,
 * flex centring and the focus/disabled contract.
 */
export const buttonBase = css `
  white-space: nowrap;
  appearance: none;
  text-decoration: none;
  box-sizing: border-box;
  font-style: normal;
  font-weight: ${theme.fontWeight.medium};
  font-size: ${theme.fontSize.medium};
  line-height: ${theme.lineHeight.default};
  border-style: solid;
  border-width: ${pxToRem(1)};
  border-radius: ${theme.borderRadius.md};
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: ${theme.spacing.md};

  &:disabled {
    pointer-events: none;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &:focus-visible {
    outline: none;
  }

  ${interactiveTransition};
`;
